@if (data$ | async; as component) {
  <div class="container" [style]="'background-color :'+ component.background">
    <div class="h2-component">{{component.title}}</div>
    <div class="description">{{component.description}}</div>
    <cx-carousel
      [items]="items$ | async "
      [template]="categoryCarousel"
      itemWidth="300px"
      [animation]="animation"
      >
    </cx-carousel>
  </div>
}


<ng-template #categoryCarousel let-item="item">
  <a [href]="item.urlLink.url">
    <span> {{item.urlLink?.linkName}}</span>
  </a>
</ng-template>
